<app-header></app-header>
<div class="last-update uppertext-no-viewport">
  <ng-container *ngIf="articleContainer.article?.lastUpdate" >
    {{'Version_published' | transloco}}: {{articleContainer.article?.lastUpdate | date : 'd MMMM yyyy'}}

  </ng-container>
</div><app-article-page-common #articleContainer></app-article-page-common>
